const data = [
    {
        "评审姓名": "徐毅",
        "介绍": "CMA评审委员会主席",
        "角色": "CMA评审委员会主席",
        "组": "主席",
        "url": "http://img01.cmicawards.org.cn/cover/评委_徐毅.jpg"
    },
    {
        "评审姓名": "李宗盛",
        "介绍": "CMA评审团首席顾问",
        "角色": "CMA评审团首席顾问",
        "组": "首席顾问",
        "url": "http://img01.cmicawards.org.cn/cover/评委_李宗盛.jpg"
    },
    {
        "评审姓名": "戈非",
        "角色": "Leader",
        "组": "戈非",
        "url": "http://img01.cmicawards.org.cn/cover/评委_戈非.jpg",
        "组员": [
            {
                "评审姓名": "沈立嘉",
                "角色": "成员",
                "组": "戈非"
            },
            {
                "评审姓名": "苗晶",
                "角色": "成员",
                "组": "戈非"
            },
            {
                "评审姓名": "小武",
                "角色": "成员",
                "组": "戈非"
            },
            {
                "评审姓名": "蒋明",
                "角色": "成员",
                "组": "戈非"
            },
            {
                "评审姓名": "Soulspeak",
                "角色": "成员",
                "组": "戈非"
            },
            {
                "评审姓名": "陈灵伟",
                "角色": "成员",
                "组": "戈非"
            },
            {
                "评审姓名": "内陆飞鱼",
                "角色": "成员",
                "组": "戈非"
            },
            {
                "评审姓名": "李青",
                "角色": "成员",
                "组": "戈非"
            },
            {
                "评审姓名": "李岱",
                "角色": "成员",
                "组": "戈非"
            },
            {
                "评审姓名": "Come lee",
                "角色": "成员",
                "组": "戈非"
            }
        ]
    },
    {
        "评审姓名": "邓柯",
        "介绍": "乐评人",
        "角色": "Leader",
        "组": "邓柯",
        "url": "http://img01.cmicawards.org.cn/cover/评委_邓柯.jpg",
        "组员": [
            {
                "评审姓名": "洪涛",
                "角色": "成员",
                "组": "邓柯"
            },
            {
                "评审姓名": "汤佩弦",
                "角色": "成员",
                "组": "邓柯"
            },
            {
                "评审姓名": "王铉",
                "角色": "成员",
                "组": "邓柯"
            },
            {
                "评审姓名": "朱金泰",
                "角色": "成员",
                "组": "邓柯"
            },
            {
                "评审姓名": "金承志",
                "角色": "成员",
                "组": "邓柯"
            },
            {
                "评审姓名": "祁又一",
                "角色": "成员",
                "组": "邓柯"
            },
            {
                "评审姓名": "相征",
                "角色": "成员",
                "组": "邓柯"
            },
            {
                "评审姓名": "迟斌",
                "角色": "成员",
                "组": "邓柯"
            },
            {
                "评审姓名": "张筱真",
                "角色": "成员",
                "组": "邓柯"
            },
            {
                "评审姓名": "刘钊",
                "角色": "成员",
                "组": "邓柯"
            }
        ]
    },
    {
        "评审姓名": "金少刚",
        "介绍": "摩登天空创始人、草莓音乐节创始人、音乐人",
        "角色": "Leader",
        "组": "金少刚",
        "url": "http://img01.cmicawards.org.cn/cover/评委_金少刚.jpg",
        "组员": [
            {
                "评审姓名": "李军",
                "角色": "成员",
                "组": "金少刚"
            },
            {
                "评审姓名": "陈珞",
                "角色": "成员",
                "组": "金少刚"
            },
            {
                "评审姓名": "章寅（老虎）",
                "角色": "成员",
                "组": "金少刚"
            },
            {
                "评审姓名": "瞿然",
                "角色": "成员",
                "组": "金少刚"
            },
            {
                "评审姓名": "王磊",
                "角色": "成员",
                "组": "金少刚"
            },
            {
                "评审姓名": "周天澈",
                "角色": "成员",
                "组": "金少刚"
            },
            {
                "评审姓名": "张军军",
                "角色": "成员",
                "组": "金少刚"
            },
            {
                "评审姓名": "赵靖",
                "角色": "成员",
                "组": "金少刚"
            },
            {
                "评审姓名": "时俊峰",
                "角色": "成员",
                "组": "金少刚"
            },
            {
                "评审姓名": "林梦洋",
                "角色": "成员",
                "组": "金少刚"
            }
        ]
    },
    {
        "评审姓名": "贾敏恕",
        "介绍": "街声股份有限公司总裁、简单生活节共同创办人",
        "角色": "Leader",
        "组": "贾敏恕",
        "url": "http://img01.cmicawards.org.cn/cover/评委_贾敏恕.jpg",
        "组员": [
            {
                "评审姓名": "老狼",
                "角色": "成员",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "王皓 (南瓜)",
                "角色": "成员",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "朱哲琴",
                "角色": "成员",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "张帆",
                "角色": "成员",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "郝舫",
                "角色": "成员",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "姚中仁",
                "角色": "成员",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "颜仲坤",
                "角色": "成员",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "郭小寒",
                "角色": "成员",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "宋晓辉",
                "角色": "成员",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "许经纶",
                "角色": "成员",
                "组": "贾敏恕"
            }
        ]
    },
    {
        "评审姓名": "陈建骐",
        "角色": "Leader",
        "组": "陈建骐",
        "url": "http://img01.cmicawards.org.cn/cover/评委_陈建骐.jpg",
        "组员": [
            {
                "评审姓名": "魏广皓",
                "角色": "成员",
                "组": "陈建骐"
            },
            {
                "评审姓名": "韩立康",
                "角色": "成员",
                "组": "陈建骐"
            },
            {
                "评审姓名": "姚国祯",
                "角色": "成员",
                "组": "陈建骐"
            },
            {
                "评审姓名": "董运昌",
                "角色": "成员",
                "组": "陈建骐"
            },
            {
                "评审姓名": "李孝祖",
                "角色": "成员",
                "组": "陈建骐"
            },
            {
                "评审姓名": "陈以霖",
                "角色": "成员",
                "组": "陈建骐"
            },
            {
                "评审姓名": "柯贵民",
                "角色": "成员",
                "组": "陈建骐"
            },
            {
                "评审姓名": "张简君伟",
                "角色": "成员",
                "组": "陈建骐"
            },
            {
                "评审姓名": "迪拉",
                "角色": "成员",
                "组": "陈建骐"
            },
            {
                "评审姓名": "魏如萱",
                "角色": "成员",
                "组": "陈建骐"
            }
        ]
    },
    {
        "评审姓名": "谭伊哲",
        "介绍": "全能型音乐家、音乐总监、编曲家、著名音乐制作人、作曲家、集合多种乐器演奏于一身、被誉为华语歌坛“音乐魔法师”",
        "角色": "Leader",
        "组": "谭伊哲",
        "url": "http://img01.cmicawards.org.cn/cover/评委_谭伊哲.jpg",
        "组员": [
            {
                "评审姓名": "金志文",
                "角色": "成员",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "程天禹",
                "角色": "成员",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "萨顶顶",
                "角色": "成员",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "周诗颖",
                "角色": "成员",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "邢天溯",
                "角色": "成员",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "李仁赫",
                "角色": "成员",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "曲世聪",
                "角色": "成员",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "姜志鹏",
                "角色": "成员",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "吴梦奇",
                "角色": "成员",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "闻震",
                "角色": "成员",
                "组": "谭伊哲"
            }
        ]
    },
    {
        "评审姓名": "金培达",
        "介绍": "资深作曲、监制、电影音乐人",
        "角色": "Leader",
        "组": "金培达",
        "url": "http://img01.cmicawards.org.cn/cover/评委_金培达.jpg",
        "组员": [
            {
                "评审姓名": "张江",
                "角色": "成员",
                "组": "金培达"
            },
            {
                "评审姓名": "Ted Lo",
                "角色": "成员",
                "组": "金培达"
            },
            {
                "评审姓名": "Viki Chan (陈咏瑜)",
                "角色": "成员",
                "组": "金培达"
            },
            {
                "评审姓名": "李念和",
                "角色": "成员",
                "组": "金培达"
            },
            {
                "评审姓名": "陳少琪",
                "角色": "成员",
                "组": "金培达"
            },
            {
                "评审姓名": "严励行 (Johnny Yim)",
                "角色": "成员",
                "组": "金培达"
            },
            {
                "评审姓名": "科钦夫",
                "角色": "成员",
                "组": "金培达"
            },
            {
                "评审姓名": "崔恕",
                "角色": "成员",
                "组": "金培达"
            },
            {
                "评审姓名": "方文山",
                "角色": "成员",
                "组": "金培达"
            },
            {
                "评审姓名": "常石磊",
                "角色": "成员",
                "组": "金培达"
            }
        ]
    },
    {
        "评审姓名": "余隆",
        "介绍": "资深作曲、监制、电影音乐人",
        "角色": "Leader",
        "组": "余隆",
        "url": "http://img01.cmicawards.org.cn/cover/评委_余隆.jpg",
        "组员": [
            {
                "评审姓名": "吴彤",
                "角色": "成员",
                "组": "余隆"
            },
            {
                "评审姓名": "王健",
                "角色": "成员",
                "组": "余隆"
            },
            {
                "评审姓名": "谭盾",
                "角色": "成员",
                "组": "余隆"
            },
            {
                "评审姓名": "刘达",
                "角色": "成员",
                "组": "余隆"
            },
            {
                "评审姓名": "邹野",
                "角色": "成员",
                "组": "余隆"
            },
            {
                "评审姓名": "王勇",
                "角色": "成员",
                "组": "余隆"
            },
            {
                "评审姓名": "沈洋",
                "角色": "成员",
                "组": "余隆"
            },
            {
                "评审姓名": "唐俊乔",
                "角色": "成员",
                "组": "余隆"
            },
            {
                "评审姓名": "陈擎",
                "角色": "成员",
                "组": "余隆"
            },
            {
                "评审姓名": "孙明章",
                "角色": "成员",
                "组": "余隆"
            }
        ]
    },
    {
        "评审姓名": "任宇清",
        "介绍": "资深作曲、监制、电影音乐人",
        "角色": "Leader",
        "组": "任宇清",
        "url": "http://img01.cmicawards.org.cn/cover/评委_任宇清.jpg",
        "组员": [
            {
                "评审姓名": "彭飞",
                "角色": "成员",
                "组": "任宇清"
            },
            {
                "评审姓名": "徐凤霞",
                "角色": "成员",
                "组": "任宇清"
            },
            {
                "评审姓名": "李泉",
                "角色": "成员",
                "组": "任宇清"
            },
            {
                "评审姓名": "小老虎",
                "角色": "成员",
                "组": "任宇清"
            },
            {
                "评审姓名": "李朗曦",
                "角色": "成员",
                "组": "任宇清"
            },
            {
                "评审姓名": "肖骏",
                "角色": "成员",
                "组": "任宇清"
            },
            {
                "评审姓名": "Laura Fygi",
                "角色": "成员",
                "组": "任宇清"
            },
            {
                "评审姓名": "Theo Croker",
                "角色": "成员",
                "组": "任宇清"
            },
            {
                "评审姓名": "武勇恒",
                "角色": "成员",
                "组": "任宇清"
            },
            {
                "评审姓名": "雷瑛 ",
                "角色": "成员",
                "组": "任宇清"
            }
        ]
    }
]

export default data